import React, { useMemo } from 'react';
import { DocumentDocIcon } from '@stepstone-genesis/icons';
import { Text, Flex, Paragraph, FlexItem } from '@stepstone-genesis/components';
import { formatDate } from '../../utils/helpers/helpers';
import { getLabel } from '../../utils/helpers/labelsService';
import { MODAL_DATA_AT } from '../consts';
export var AttachmentItem = function (_a) {
    var attachment = _a.attachment;
    var addedOnLabel = useMemo(function () { return getLabel('addedOn'); }, []);
    return (React.createElement(Flex, { "data-at": "".concat(MODAL_DATA_AT, "-attachment-item"), p: ['spaceNone', 'spaceNone'], pt: ['spaceM', 'spaceL'], flxDirection: ['column', 'row'], flxItems: "center", flxJustify: "space-between" },
        React.createElement(Flex, { flxItems: 'center', sx: { width: ['100%', 'auto'] }, pb: ['spaceM', 'spaceNone'] },
            React.createElement(DocumentDocIcon, { color: "colorBrandDefault", size: "xxl", mr: "spaceM" }),
            React.createElement(Flex, { flxDirection: "column" },
                React.createElement(FlexItem, { flxOrder: 'start' },
                    React.createElement(Text, { sx: { height: 'auto' }, fontWeight: 'fontWeightBold', wordBreak: 'break-word' }, attachment.name)),
                attachment.createdAt && (React.createElement(Paragraph, { color: "colorGreyDark", "data-at": "".concat(MODAL_DATA_AT, "-attachment-created-date") }, "".concat(addedOnLabel, " "),
                    formatDate(attachment.createdAt, {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric',
                    })))))));
};
//# sourceMappingURL=index.js.map